<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          ref="filterRef"
          :filters="filterManagerConfig"
          :display-advanced="false"
          search-text=""
          v-model="model.search.filters"
        >
          <div class="d-flex align-items-start mt-1 ml-3">
            <action-button
              id="process-evaluation-tracking-search"
              i="fa fa-sync pr-2"
              variant="success px-3"
              @click="onHandlerSearch"
            >
              Procesar
            </action-button>
          </div>
        </filter-manager>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import ActionButton from 'ActionButton'
import AcademicYearServices from '@/services/api/academicyear.api'
import codeAcademicYear from '@/utils/constants/codeAcademicYear.js'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'
export default {
  name: 'EvaluationTracking',
  components: {
    PageHeader,
    FilterManager,
    ActionButton,
  },
  data: () => ({
    page: {
      icon: 'fas fa-chart-pie',
      title: 'Informe Seguimiento Evaluaciones',
      routes: ['Informes', 'Informe Seguimiento Evaluaciones'],
    },
    model: {
      search: {
        collections: {
          status: [],
          academicYears: [],
        },
        filters: {
          status: null,
          academicYears: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYears',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          class: 'col-12 col-md-3',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYears,
        },
      ]
    },
  },
  async mounted() {
    this.setFilters()
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getAcademicYearsFromSpecificYear(
        codeAcademicYear['2016-2017']
      ).then((res) => (this.model.search.collections.academicYears = res.data))
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (isValid) {
        this.process()
      }
    },
    async process() {
      // Exec Report
   
    await ReportServices.getReport('evaluationtracking', {
        academicYearId: this.model.search.filters.academicYears.id,
      }).then((res) => DocumentServices.Download(res.data))
    },
      
  },
}
</script>

<style>
</style>